/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ConfirmArrivalRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {ConfirmArrivalResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const confirmArrival = (request: ConfirmArrivalRequest, options?: CashRequestOptions) => post<ConfirmArrivalRequest, ConfirmArrivalResponse>("/cash-app/local/order/confirm-arrival", request, {...options, rejectOnError: true })